import { createStore } from 'vuex';

export default createStore({
  state: {
    _this: '',
    themetype: '浅色',
    getUserInfo: {}, // 用户信息
    memberInfo: {}, // 会员信息
    wechatPayGoodsInfo: {}, // 购买列表
    wechatPayGoodsInfoTop: {},
    avatar: '', // 头像
    nickName: '', // 呢称
    sessionId: '', // 登录标识
    userId: '',
    openid: '',
    isWX: false, // 是否微信浏览器
    // isLogin: false, // 是否登录
    // isVIP: false, // 是否会员
    customerMobile: '', // 手机号
    nowTabbarIndex: 0,
    isLoading: false,
    isShowPage: true,
    popDalogue: {}, // 当前机器人信息
    nowWindow: { // 当前窗口
      windowName: '新对话',
      windowId: ''
    },
    msgList: [], // 对话数据
    // 历史对话列表
    popDalogueHistory: [],
    AIDalogueMarket: [],
    activeIndex: '',
    active: 0,
    sidebarIndex: 1,
    appTypeList: [],
    tabbarList: [
      {
        index: 0,
        name: '首页',
        pageUrl: '/HomeList',
        icon: 'chat-o'
      },
      {
        index: 1,
        name: '对话',
        pageUrl: '/HomePage',
        icon: 'chat-o'
      },
      // {
      //   index: 4,
      //   name: 'AI市场',
      //   pageUrl: '/HealthServices',
      //   icon: 'shop-o'
      // },
      {
        index: 3,
        name: ' AI图片',
        pageUrl: '/AiPicture',
        icon: 'phone-circle-o'
      },
      {
        index: 2,
        name: ' AI视频',
        pageUrl: '/VoiceComponent',
        icon: 'phone-circle-o'
      },
      {
        index: 5,
        name: '我的',
        pageUrl: '/MineHealth',
        icon: 'manager-o'
      }
    ],
    // AI市场 我的常用
    HSMyCommonList: [],
    // AI市场 AI聊天
    HSInquiryServiceList: [],
    // 我的 登录列表
    MHGongGongMyServiceList: [],
    // 我的 未登录列表
    MHMyServiceList: [],
    // -------------------------------------------------------------------------
    // 模式  ordinary-普通版  care-关怀版
    version: 'ordinary',
    negative_prompt: '',
    prompt: '',
    cfg_scale: 0.5,
    mode: 'std',
    VideoMode: [{
      name: '标准',
      value: 'std'
    }, {
      name: '高品质',
      value: 'pro'
    }],
    duration: '5',
    VideoDuration: [{
      name: '5s',
      value: '5'
    }, {
      name: '10s',
      value: '10'
    }],
    aspect_ratio: '16:9',
    VideoAspect: [{
      name: '16:9',
      value: '16:9'
    }, {
      name: '9:16',
      value: '9:16'
    }, {
      name: '1:1',
      value: '1:1'
    }],
    camera_control_name: '无',
    camera_control_type: '',
    camera_control_number: 0,
    VideoCamera: [{
      text: '无',
      value: ''
    }, {
      text: '水平运镜',
      value: 'simple'
    }, {
      text: '垂直运镜',
      value: 'simple'
    },
    {
      text: '水平摇镜',
      value: 'simple'
    },
    {
      text: '垂直摇镜',
      value: 'simple'
    },
    {
      text: '旋转运镜',
      value: 'simple'
    },
    {
      text: '拉远/推进',
      value: 'simple'
    }, {
      text: '大师运镜：下拉远移',
      value: 'down_back'
    }, {
      text: '大师运镜：推进上移',
      value: 'forward_up'
    }, {
      text: '大师运镜：右旋推进',
      value: 'right_turn_forward'
    }, {
      text: '大师运镜：左旋推进',
      value: 'left_turn_forward'
    }],
    isvideoUrlExample: '1',
    vipDialog: false,
    vipDialogType: true,
    activeIndexTop: 0,
    activeIndexVip: 0,
    refreshList: [
    ],
    isvideoUrlExamplePicture: '1',
    promptPicture: '',
    modePicture: 'standard',
    VideoModePicture: [{
      name: '标准',
      value: 'standard'
    }, {
      name: '高品质',
      value: 'hd'
    }],
    stylePicture: 'vivid',
    VideostylePicture: [{
      name: '鲜艳',
      value: 'vivid'
    }, {
      name: '自然',
      value: 'natural'
    }],
    aspect_ratioPicture: '1024x1024',
    VideoAspectPicture: [{
      name: '1024x1024',
      value: '1024x1024'
    }, {
      name: '1792x1024',
      value: '1792x1024'
    }, {
      name: '1024x1792',
      value: '1024x1792'
    }],
    integralPicture: '0',
    integralVoice: '0',
    refreshImageList: [],
    refreshVideoList: [],
    chooseVipDialogInfo: {},
    Picturemap: {
    },
    multiple: [
      // {
      //   name: '1倍',
      //   value: '1'
      // },
      {
        name: '2倍',
        value: 2
      }, {
        name: '3倍',
        value: 3
      }, {
        name: '4倍',
        value: 4
      }],
    multipleType: 2,
    colorServerId: '',
    multipleServerId: '',
    colorpreviewImageSrc: '',
    multiplepreviewImageSrc: '',
    firstFrameImageSrc: '',
    firstFrameServerId: '',
    tailFrameImageSrc: '',
    tailFrameServerId: '',
    switchFrame: 'first',
    klingImage2map: {},
    klingImage2ServerId: '',
    klingImage2previewImageSrc: '',
    klingmodel_name: 'kling-v1',
    klingmodel_nameList: [
      {
        name: '可灵1.0',
        value: 'kling-v1'
      },
      {
        name: '可灵1.5',
        value: 'kling-v1-5'
      },
      {
        name: '可灵1.6',
        value: 'kling-v1-6'
      }
    ],
    klingImage2negative_prompt: '',
    klingImage2prompt: '',
    klingImage2cfg_scale: 0.5,
    klingImage2mode: 'std',
    klingImage2VideoMode: [{
      name: '标准',
      value: 'std'
    }, {
      name: '高品质',
      value: 'pro'
    }],
    klingImage2duration: '5',
    klingImage2VideoDuration: [{
      name: '5s',
      value: '5'
    }, {
      name: '10s',
      value: '10'
    }],
    klingImage2aspect_ratio: '16:9',
    klingImage2VideoAspect: [{
      name: '16:9',
      value: '16:9'
    }, {
      name: '9:16',
      value: '9:16'
    }, {
      name: '1:1',
      value: '1:1'
    }],
    isPlay: false,
    isModalVisible: false,
    imageUrlModal: '',
    PCAppTypeList: [],
    PCVideoList: [],
    MJratioPicture: '1:1',
    MJAspectPicture: [{
      name: '1:1',
      value: '1:1'
    }, {
      name: '4:3',
      value: '4:3'
    }, {
      name: '3:4',
      value: '3:4'
    }, {
      name: '16:9',
      value: '16:9'
    }, {
      name: '9:16',
      value: '9:16'
    }],
    MJtabs: [
      {
        title: '风格',
        key: 'MJstyleList',
        value: 'MJstyle'
      }, {
        title: '视角',
        key: 'MJvisualList',
        value: 'stylevisual'
      }, {
        title: '人物镜头',
        key: 'MJCharacterList',
        value: 'MJCharacter'
      }, {
        title: '灯光',
        key: 'MJLightingList',
        value: 'MJLighting'
      }, {
        title: '画质',
        key: 'MJqualityList',
        value: 'MJquality'
      }, {
        title: '艺术程度',
        key: 'MJartisticList',
        value: 'MJartistic'
      }, {
        title: '模型版本',
        key: 'MJversionList',
        value: 'MJversion'
      }, {
        title: '内容一致性',
        src: 'MJcrefImageSrc',
        ServerId: 'MJcrefServerId',
        describe: '使用参考图像的内容来生成新图像'
      }, {
        title: '风格一致性',
        src: 'MJsrefImageSrc',
        ServerId: 'MJsrefServerId',
        describe: '使用参考图像的风格来生成新图像'
      }
    ],
    MJstyle: '',
    MJstyleList: [
      {
        name: '赛博朋克',
        value: 'Cyberpunk'
      }, {
        name: '星际',
        value: 'Warframe'
      }, {
        name: '动漫',
        value: 'ACGN'
      }, {
        name: '日本动漫',
        value: 'Japanese comics/manga'
      }, {
        name: '水墨画风格',
        value: 'Ink Wash Painting Style'
      }, {
        name: '原创',
        value: 'Original'
      }, {
        name: '风景画',
        value: 'landscape'
      }, {
        name: '插画',
        value: 'illustration'
      }, {
        name: '现代自然',
        value: 'modern organic'
      }, {
        name: '创世纪',
        value: 'Genesis'
      }, {
        name: '海报风格',
        value: 'posterstyle'
      }, {
        name: '超现实主义',
        value: 'surrealism'
      }, {
        name: '素描',
        value: 'sketch'
      }, {
        name: '写实',
        value: 'realism'
      }, {
        name: '水彩画',
        value: 'Watercolor painting'
      }, {
        name: '立体主义',
        value: 'Cubism'
      }, {
        name: '黑白',
        value: 'black and white'
      }, {
        name: '胶片摄影风格',
        value: 'fm photography'
      }, {
        name: '电影化',
        value: 'cinematic'
      }, {
        name: '清晰的面部特征',
        value: 'dlear facial features'
      }],
    stylevisual: '',
    MJvisualList: [
      {
        name: '宽视角',
        value: 'Wide view,'
      }, {
        name: '鸟瞰视角',
        value: 'Aerial view'
      }, {
        name: '顶视角',
        value: 'Top view'
      }, {
        name: '仰视角',
        value: 'Upview'
      }, {
        name: '正面视角',
        value: 'Front view'
      }, {
        name: '头部特写',
        value: 'Headshot'
      }, {
        name: '超广角视角',
        value: 'Ultrawideshot'
      }, {
        name: '中景',
        value: 'Medium Shot(MS)'
      }, {
        name: '远景',
        value: 'Long Shot(LS)'
      }, {
        name: '景深',
        value: 'depth offield(dof)'
      }],
    MJCharacter: '',
    MJCharacterList: [
      {
        name: '脸部特写',
        value: 'Face Shot (VCU)'
      }, {
        name: '大特写',
        value: 'Big Close-Up(BCU)'
      }, {
        name: '特写',
        value: 'Close-Up(CU)'
      }, {
        name: '腰部以上',
        value: 'Waist Shot(WS)'
      }, {
        name: '膝盖以上',
        value: 'KneeShot(KS)'
      }, {
        name: '全身照',
        value: 'Full Length Shot(FLS)'
      }, {
        name: '极远景',
        value: 'Extra Long Shot(ELS)'
      }],
    MJLighting: '',
    MJLightingList: [
      {
        name: '冷光',
        value: 'Cold light'
      }, {
        name: '暖光',
        value: 'Warm light'
      }, {
        name: '硬光',
        value: 'hard lighting'
      }, {
        name: '戏剧性光线',
        value: 'Dramatic light'
      }, {
        name: '反射光',
        value: 'reflection light'
      }, {
        name: '薄雾',
        value: 'Misty foggy'
      }, {
        name: '自然光',
        value: 'Natural light'
      }, {
        name: '阳光',
        value: 'Sun light'
      }, {
        name: '情绪化',
        value: 'moody'
      }],
    MJquality: '',
    MJqualityList: [
      {
        name: '一般',
        value: '0.25'
      }, {
        name: '清晰',
        value: '0.5'
      }, {
        name: '高清',
        value: '1'
      }, {
        name: '超高清',
        value: '2'
      }],
    MJartistic: '',
    MJartisticList: [
      {
        name: '低强度风格',
        value: '50'
      }, {
        name: '中等强度风格',
        value: '100'
      }, {
        name: '高强度风格',
        value: '250'
      }, {
        name: '非常高强度风格',
        value: '750'
      }],
    MJversion: 'V6.1',
    MJversionList: [
      // {
      //   name: 'MJ V7.0',
      //   value: 'V7.0'
      // },
      {
        name: 'MJ V6.1',
        value: 'V6.1'
      }, {
        name: 'MJ V6',
        value: 'V6.0'
      },
      // {
      //   name: 'MJ V5.2',
      //   value: 'V5.2'
      // }, {
      //   name: 'MJ V5.1',
      //   value: 'V5.1'
      // },
      {
        name: 'Niji V6',
        value: 'niji 6'
      }
      // , {
      //   name: 'Niji V5',
      //   value: 'niji 5'
      // }
    ],
    contentWeight: 100,
    styleWeight: 100,
    imageWeight: 1,
    MJcrefServerId: '',
    MJcrefImageSrc: '',
    MJsrefServerId: '',
    MJsrefImageSrc: '',
    isMJMat: false,
    MJMatSrcList: [],
    MJMatServerIdList: [],
    MJpromptPicture: '',
    MJremix: true,
    showCenter: false,
    showCenterItem: {},
    showCenterIndex: '',
    drawingList: [],
    HomeAppListIndex: '',
    credentials: null,
    AIGenerateVideo_prompt: '',
    AIGenerateVideo_ratio: '9:16',
    AIGenerateVideo_aspect: [{
      name: '竖屏',
      value: '9:16'
    }, {
      name: '横屏',
      value: '16:9'
    }],
    AIGenerateVideo_mode: 'SD',
    AIGenerateVideo_VideoMode: [{
      name: '标清',
      value: 'SD'
    }, {
      name: '高清',
      value: 'HD'
    }, {
      name: '超高清',
      value: 'UHD'
    }],
    AIGenerateVideo_subtitles: false,
    AIGenerateVideo_selectedHex: '#ffffff', // 默认颜色为白色
    AIGenerateVideo_selectedAlpha: 1,
    AIGenerateVideo_bgselectedHex: '#927070', // 默认颜色为白色
    AIGenerateVideo_bgselectedAlpha: 0.32,
    AIGenerateVideo_subtitlePosition: 170,
    AIGenerateVideo_islogo: false,
    AIGenerateVideo_marginalDistance: 20,
    AIGenerateVideo_logoDistance: 'top-left',
    AIGenerateVideo_logoDistanceList: [{
      name: '左上',
      value: 'top-left'
    }, {
      name: '右上',
      value: 'top-right'
    }],
    AIGenerateVideo_logoUrl: '',
    AIGenerateVideo_templateId: '',
    AIGenerateVideo_templateUrl: '',
    AIGenerateVideo_audioName: '度姗姗',
    AIGenerateVideo_ttsPer: 4144,
    AIGenerateVideo_bgMusic: '无',
    AIGenerateVideo_bgMusicUrl: '',
    AIGenerateVideo_mediaSource: [],
    folderId: 0,
    materialListTyle: 'file',
    folderitem: '素材列表',
    OldPhotoServerId: '',
    OldPhotoImageSrc: '',
    JMpromptPicture: '',
    JMaspect_ratioPicture: '512*512',
    JMVideoAspectPicture: [{
      name: '1:1',
      value: '512*512'
    }, {
      name: '4:3',
      value: '512*384'
    }, {
      name: '3:4',
      value: '384*512'
    }, {
      name: '3:2',
      value: '512*341'
    }, {
      name: '2:3',
      value: '341*512'
    }, {
      name: '16:9',
      value: '512*288'
    }, {
      name: '9:16',
      value: '288*512'
    }],
    KLpromptPicture: '',
    KLaspect_ratioPicture: '512*512',
    KLVideoAspectPicture: [
      {
        name: '1:1',
        value: '512*512'
      }, {
        name: '4:3',
        value: '512*384'
      }, {
        name: '3:4',
        value: '384*512'
      }, {
        name: '3:2',
        value: '512*341'
      }, {
        name: '2:3',
        value: '341*512'
      }, {
        name: '16:9',
        value: '512*288'
      }, {
        name: '9:16',
        value: '288*512'
      }
    //   {
    //   name: '1:1',
    //   value: '1:1'
    // }, {
    //   name: '4:3',
    //   value: '4:3'
    // }, {
    //   name: '3:4',
    //   value: '3:4'
    // }, {
    //   name: '3:2',
    //   value: '3:2'
    // }, {
    //   name: '2:3',
    //   value: '2:3'
    // }, {
    //   name: '16:9',
    //   value: '16:9'
    // }, {
    //   name: '9:16',
    //   value: '9:16'
    // }
    ],
    isKLMat: false,
    KLimage: '',
    KL916promptPicture: '',
    isKL916Mat: false,
    KL916image: '',
    DouBaopromptPicture: '',
    DouBaospect_ratioPicture: '1:1',
    DouBaoVideoAspectPicture: [
      {
        name: '1:1',
        value: '1:1'
      }, {
        name: '3:4',
        value: '3:4'
      }, {
        name: '4:3',
        value: '4:3'
      }, {
        name: '16:9',
        value: '16:9'
      }, {
        name: '9:16',
        value: '9:16'
      }, {
        name: '3:2',
        value: '3:2'
      }, {
        name: '2:3',
        value: '2:3'
      }, {
        name: '21:9',
        value: '21:9'
      }
    ],
    isDouBaoMat: false,
    DouBaoimageList: [],
    // GptImage2 配置
    GptImage2promptPicture: '',
    GptImage2spect_ratioPicture: '1:1',
    GptImage2style: 'vivid',
    GptImage2quality: '1k',
    isGptImage2Mat: false,
    GptImage2List: [],
    GptImage2VideoAspectPicture: [],
    GptImage2StyleList: [
      { name: '鲜艳', value: 'vivid' },
      { name: '自然', value: 'natural' }
    ],
    GptImage2QualityList: [
      { name: '1K', value: '1k' },
      { name: '2K', value: '2k' }
    ],
    message: '',
    messageimage: [],
    // Seedance 2.0 Fast 模式配置
    seedance2Fast_prompt: '',
    seedance2Fast_resolution: '480p',
    seedance2Fast_ratio: '16:9',
    seedance2Fast_duration: 5,
    seedance2Fast_generate_audio: true,
    seedance2Fast_firstFrame: null,
    seedance2Fast_lastFrame: null,
    seedance2Fast_referenceImages: [],
    seedance2Fast_firstFrameTime: null,
    seedance2Fast_lastFrameTime: null,

    // Seedance 2.0 Pro 模式配置
    seedance2Pro_prompt: '',
    seedance2Pro_resolution: '720p',
    seedance2Pro_ratio: '16:9',
    seedance2Pro_duration: 10,
    seedance2Pro_generate_audio: true,
    seedance2Pro_web_search: false,
    seedance2Pro_firstFrame: null,
    seedance2Pro_lastFrame: null,
    seedance2Pro_referenceImages: [],
    seedance2Pro_videos: [],
    seedance2Pro_audios: [],
    seedance2Pro_videoTimes: [],

    // Seedance 2.0 通用选项列表
    seedance2ResolutionList: [
      {
        name: '480p',
        value: '480p'
      },
      {
        name: '720p',
        value: '720p'
      }
    ],
    seedance2RatioList: [
      {
        name: '16:9',
        value: '16:9'
      },
      {
        name: '9:16',
        value: '9:16'
      },
      {
        name: '1:1',
        value: '1:1'
      },
      {
        name: '4:3',
        value: '4:3'
      },
      {
        name: '3:4',
        value: '3:4'
      },
      {
        name: '21:9',
        value: '21:9'
      }
    ],
    seedance2FastDurationList: [
      {
        name: '4s',
        value: 4
      },
      {
        name: '5s',
        value: 5
      },
      {
        name: '8s',
        value: 8
      },
      {
        name: '10s',
        value: 10
      },
      {
        name: '12s',
        value: 12
      }
    ],
    seedance2ProDurationList: [
      {
        name: '4s',
        value: 4
      },
      {
        name: '5s',
        value: 5
      },
      {
        name: '8s',
        value: 8
      },
      {
        name: '10s',
        value: 10
      },
      {
        name: '15s',
        value: 15
      }
    ]
  },
  getters: {
  },
  mutations: {
    changeStoreDataFun (state, params) {
      state[params.key] = params.value;
    }
  },
  actions: {
    /**
     * 纯赋值方法
     * @param 对象类型或数组类型
     * @param {*} key  必传
     * @param {*} value  必传
    */
    changeStoreData ({ commit }, value) {
      if (value.length) {
        value.forEach(element => {
          commit('changeStoreDataFun', element);
        });
      } else {
        commit('changeStoreDataFun', value);
      }
    }
  }
});
